import usePricing from "./usePricing.js";
import { Navbar2 } from "../../Components/Navbar2/Navbar2.js";
import SimpleFooter from "../../Components/SimpleFooter.jsx";
import PricingCard from "../../Components/PricingCard.jsx";
import CheckoutDrawer from "../Checkout/CheckoutDrawer.js";
import LoginModal from "../Login/LoginModal";
import { useState } from "react";
import UpdatePlanConfirmationModal from "../../Components/UpdatePlanConfirmationModal.jsx";
import { useNavigate } from "react-router-dom";
import PaymentModal from "../../Components/PaymentModal.jsx";
import EmailVerificationModal from "../Login/EmailVerificationModal.jsx";
import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import CustomPlanModal from "../../Components/CustomPlanModal.jsx";


export default function Pricing({navigator}) {
  const navigate=useNavigate()
const [showVerificationModal, setShowVerificationModal] = useState(false);
const [showLoginModal, setShowLoginModal] = useState(false);
const [showCheckout, setShowCheckout] = useState(false);
const [showUpgradeModal, setShowUpgradeModal] = useState(false);
const [showCustomPlanModal, setShowCustomPlanModal] = useState(false);
const [openFAQ, setOpenFAQ] = useState(null);

const {subscriptionList,token,
  planeId,
    modalType,
    errorMessage,
    my_subscription,
    selectedSubscription,
    isCancelled,
    isVerify,
    onConfirmUpgrade,
    setSelectedSubscription,
    handelModalType,
}= usePricing()
const isAdminCreated=my_subscription?.isCustomAssignedByAdmin
const handlePlanClick = (plan) => {
  if (plan?.name === 'Custom') {
    setShowCustomPlanModal(true);
    return;
  }
  if (!token) {
    setShowLoginModal(true);
    return;
  }
  if (plan?.price===0){
    navigate("/Dashboard")
    return
  }
  if(!isVerify){
   setShowVerificationModal(true)
    return 
  }
  if(planeId?.length){
    setShowUpgradeModal(true)
    setSelectedSubscription(plan)
    return
  }
  setShowCheckout(true);
  // navigate("/Checkout")
};

const toggleFAQ = (index) => {
  setOpenFAQ(openFAQ === index ? null : index);
};
console.log("my_subscription-----------",my_subscription)
const sortedSubscriptionList = [...(subscriptionList || [])].sort((a, b) => {
  if (a.name === 'Custom') return 1;
  if (b.name === 'Custom') return -1;
  return 0;
});

  return (
 <>
<Navbar2 />
<>

  <div 
  style={{ background: 'linear-gradient(135deg,rgb(24, 32, 47) 0%, #2E428A 50%,rgb(24, 32, 47) 100%)' }}
  className="px-6 sm:px-8 md:px-20 min-h-screen py-10 md:pb-28 md:pt-28 lg:px-44 flex flex-col justify-center items-center">
    {/* Pricing Header */}
    <div className="text-center mb-6 md:mb-16">
      <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
       Pricing
      </h2>
    </div>
    {/* Pricing Cards Container */}
 <div className="flex flex-wrap justify-center items-start gap-6 w-full max-w-7xl">
  {sortedSubscriptionList?.map((plan) => (
    <div key={plan._id} className="w-full sm:w-80 md:w-72 lg:w-80">
      <PricingCard 
       mySubscription={my_subscription}
      isCancelled={isCancelled}
       planeId={planeId}
       onClickCard={handlePlanClick}
        plan={plan} 
        isAdminCreated={isAdminCreated}
        />
    </div>
  ))}
</div>

 
    {/* FAQ Section Toggle */}
    <div className="mt-16 text-center w-full">
    <>
 
  <div className="container mx-auto px-0 md:px-20 py-12 max-w-7xl w-full">
    {/* Header */}
    <div className="text-center mb-12">
      <h1 className="text-4xl font-bold text-white mb-4">
      Frequently Asked Question
      </h1>
     
    </div>


    <div className="space-y-4 w-full">
      {/* FAQ Item 1 */}
      <div className="bg-[#212C43] border border-[#4A5567] rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg w-full">
        <button 
          onClick={() => toggleFAQ(0)}
          className="faq-toggle w-full flex justify-between items-center p-6 text-left"
        >
          <h3 className="text-lg font-semibold text-white">
          How do I set up custom weather alerts?
          </h3>
          {openFAQ === 0 ? (
            <ChevronUpIcon className="w-6 h-6 text-[#3662E3] transition-transform duration-300" />
          ) : (
            <ChevronDownIcon className="w-6 h-6 text-[#3662E3] transition-transform duration-300" />
          )}
        </button>
        <div className={`faq-content px-6 pb-6 transition-all duration-300 ${openFAQ === 0 ? 'block' : 'hidden'}`}>
          <p className="text-gray-300 text-left">
          Once logged in, go to the "Alerts" tab on your dashboard and click "Create Alert." You can specify the type, trigger, and delivery method.
          </p>
        </div>
      </div>
      
      {/* FAQ Item 2 */}
      <div className="bg-[#212C43] border border-[#4A5567] rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg w-full">
        <button 
          onClick={() => toggleFAQ(1)}
          className="faq-toggle w-full flex justify-between items-center p-6 text-left"
        >
          <h3 className="text-lg font-semibold text-white">
          What happens when I exceed the limit on alerts (Free or Pro)?
          </h3>
          {openFAQ === 1 ? (
            <ChevronUpIcon className="w-6 h-6 text-[#3662E3] transition-transform duration-300" />
          ) : (
            <ChevronDownIcon className="w-6 h-6 text-[#3662E3] transition-transform duration-300" />
          )}
        </button>
        <div className={`faq-content px-6 pb-6 transition-all duration-300 ${openFAQ === 1 ? 'block' : 'hidden'}`}>
          <p className="text-gray-300 mb-3 text-left">
          You'll receive a notification prompting you to upgrade. Additional alerts will not be delivered until the limit resets or you upgrade.
          </p>
        </div>
      </div>
      
      {/* FAQ Item 3 */}
      <div className="bg-[#212C43] border border-[#4A5567] rounded-xl shadow-md overflow-hidden transition-all duration-300 hover:shadow-lg w-full">
        <button 
          onClick={() => toggleFAQ(2)}
          className="faq-toggle w-full flex justify-between items-center p-6 text-left"
        >
          <h3 className="text-lg font-semibold text-white">
            Can I cancel my subscription anytime?
          </h3>
          {openFAQ === 2 ? (
            <ChevronUpIcon className="w-6 h-6 text-[#3662E3] transition-transform duration-300" />
          ) : (
            <ChevronDownIcon className="w-6 h-6 text-[#3662E3] transition-transform duration-300" />
          )}
        </button>
        <div className={`faq-content px-6 pb-6 transition-all duration-300 ${openFAQ === 2 ? 'block' : 'hidden'}`}>
          <p className="text-gray-300 text-left">
            Yes, you can cancel your subscription at any time. If you cancel
            during your billing period, you'll continue to have access to our
            services until the end of that period. We don't charge any
            cancellation fees.
          </p>
        </div>
      </div>
    </div>

  </div>
  {/* JavaScript for FAQ functionality */}
</>

    </div>
  </div>
<CheckoutDrawer
  modalType={modalType}
    errorMessage={errorMessage}
    handelModalType={handelModalType}
 isOpen={showCheckout} 
 onClose={() => setShowCheckout(false)}
  />
<LoginModal open={showLoginModal} onClose={() => setShowLoginModal(false)} />
  <UpdatePlanConfirmationModal
  show={showUpgradeModal}
  onClose={() => setShowUpgradeModal(false)}
  currentPlan={{ name:my_subscription?.planId?.name, price: my_subscription?.planId?.price }}
  newPlan={{ name: selectedSubscription?.name, price:selectedSubscription?.price, nextBillingDate: "25 July, 2025", }}
  onConfirm={() => {
    // Call your upgrade logic
    setShowUpgradeModal(false)
    onConfirmUpgrade()
  }}
/>
   {modalType && (
        <PaymentModal handelModalType={handelModalType} type={modalType} errorMessage={errorMessage} />
      )}
        <EmailVerificationModal open={showVerificationModal}  onClose={()=>setShowVerificationModal(false)} />
          <CustomPlanModal open={showCustomPlanModal} onClose={()=>setShowCustomPlanModal(false)} />
</>

<SimpleFooter/>
      </>
  );
}

